import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=5baccb62&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"
import style0 from "./audio.vue?vue&type=style&index=0&id=5baccb62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baccb62",
  null
  
)

export default component.exports